import {validatenull} from './validate'
import request from '@/router/axios'
import * as CryptoJS from 'crypto-js'
import axios from 'axios'
import FileSaver from 'file-saver'
import {Message} from 'element-ui'

// 表单序列化
export const serialize = (data) => {
	const list = []
	Object.keys(data).forEach((ele) => {
		list.push(`${ele}=${data[ele]}`)
	})
	return list.join('&')
}

//日期转中文
export const CNDateString = (date) => {
	let cn = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九']
	let s = []
	let YY = date.getFullYear().toString()
	for (let i = 0; i < YY.length; i++) {
		if (cn[YY.charAt(i)]) {
			s.push(cn[YY.charAt(i)])
		} else {
			s.push(YY.charAt(i))
		}
	}
	s.push('年 ')
	let MM = date.getMonth() + 1
	if (MM < 10) {
		s.push(cn[MM])
	} else if (MM < 20) {
		s.push('十' + cn[MM % 10])
	}
	s.push('月')
	let DD = date.getDate()
	if (DD < 10) {
		s.push(cn[DD])
	} else if (DD < 20) {
		s.push('十' + cn[DD % 10])
	} else {
		s.push('二十' + cn[DD % 10])
	}
	s.push('日')
	return s.join('')
}
export const getObjType = (obj) => {
	var toString = Object.prototype.toString
	var map = {
		'[object Boolean]': 'boolean',
		'[object Number]': 'number',
		'[object String]': 'string',
		'[object Function]': 'function',
		'[object Array]': 'array',
		'[object Date]': 'date',
		'[object RegExp]': 'regExp',
		'[object Undefined]': 'undefined',
		'[object Null]': 'null',
		'[object Object]': 'object',
	}
	if (obj instanceof Element) {
		return 'element'
	}
	return map[toString.call(obj)]
}
/**
 * 对象深拷贝
 */
export const deepClone = (data) => {
	var type = getObjType(data)
	var obj
	if (type === 'array') {
		obj = []
	} else if (type === 'object') {
		obj = {}
	} else {
		// 不再具有下一层次
		return data
	}
	if (type === 'array') {
		for (var i = 0, len = data.length; i < len; i++) {
			obj.push(deepClone(data[i]))
		}
	} else if (type === 'object') {
		for (var key in data) {
			obj[key] = deepClone(data[key])
		}
	}
	return obj
}
/**
 * 判断路由是否相等
 */
export const diff = (obj1, obj2) => {
	delete obj1.close
	var o1 = obj1 instanceof Object
	var o2 = obj2 instanceof Object
	if (!o1 || !o2) {
		/*  判断不是对象  */
		return obj1 === obj2
	}

	if (Object.keys(obj1).length !== Object.keys(obj2).length) {
		return false
		// Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
	}

	for (var attr in obj1) {
		var t1 = obj1[attr] instanceof Object
		var t2 = obj2[attr] instanceof Object
		if (t1 && t2) {
			return diff(obj1[attr], obj2[attr])
		} else if (obj1[attr] !== obj2[attr]) {
			return false
		}
	}
	return true
}
/**
 * 设置灰度模式
 */
export const toggleGrayMode = (status) => {
	if (status) {
		document.body.className = document.body.className + ' grayMode'
	} else {
		document.body.className = document.body.className.replace(' grayMode', '')
	}
}
/**
 * 设置主题
 */
export const setTheme = (name) => {
	document.body.className = name
}

/**
 *加密处理
 */
export const encryption = (params) => {
	let {data, type, param, key} = params
	const result = JSON.parse(JSON.stringify(data))
	if (type === 'Base64') {
		param.forEach((ele) => {
			result[ele] = btoa(result[ele])
		})
	} else {
		param.forEach((ele) => {
			var data = result[ele]
			key = CryptoJS.enc.Latin1.parse(key)
			var iv = key
			// 加密
			var encrypted = CryptoJS.AES.encrypt(data, key, {
				iv: iv,
				mode: CryptoJS.mode.CFB,
				padding: CryptoJS.pad.NoPadding,
			})
			result[ele] = encrypted.toString()
		})
	}
	return result
}

/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
	if (fullscreenEnable()) {
		exitFullScreen()
	} else {
		reqFullScreen()
	}
}
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
	function listen() {
		callback()
	}

	document.addEventListener('fullscreenchange', function () {
		listen()
	})
	document.addEventListener('mozfullscreenchange', function () {
		listen()
	})
	document.addEventListener('webkitfullscreenchange', function () {
		listen()
	})
	document.addEventListener('msfullscreenchange', function () {
		listen()
	})
}
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
	return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
}

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
	if (document.documentElement.requestFullScreen) {
		document.documentElement.requestFullScreen()
	} else if (document.documentElement.webkitRequestFullScreen) {
		document.documentElement.webkitRequestFullScreen()
	} else if (document.documentElement.mozRequestFullScreen) {
		document.documentElement.mozRequestFullScreen()
	}
}
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
	if (document.documentElement.requestFullScreen) {
		document.exitFullScreen()
	} else if (document.documentElement.webkitRequestFullScreen) {
		document.webkitCancelFullScreen()
	} else if (document.documentElement.mozRequestFullScreen) {
		document.mozCancelFullScreen()
	}
}
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
	for (let i = 0; i < menu.length; i++) {
		if (menu[i].children.length !== 0) {
			for (let j = 0; j < menu[i].children.length; j++) {
				if (menu[i].children[j].id === id) {
					return menu[i]
				} else {
					if (menu[i].children[j].children.length !== 0) {
						return findParent(menu[i].children[j].children, id)
					}
				}
			}
		}
	}
}

/**
 * 动态插入css
 */

export const loadStyle = (url) => {
	const link = document.createElement('link')
	link.type = 'text/css'
	link.rel = 'stylesheet'
	link.href = url
	const head = document.getElementsByTagName('head')[0]
	head.appendChild(link)
}
/**
 * 判断路由是否相等
 */
export const isObjectValueEqual = (a, b) => {
	let result = true
	Object.keys(a).forEach((ele) => {
		const type = typeof a[ele]
		if (type === 'string' && a[ele] !== b[ele]) {
			result = false
		} else if (type === 'object' && JSON.stringify(a[ele]) !== JSON.stringify(b[ele])) {
			result = false
		}
	})
	return result
}
/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
	let result = ''
	if (validatenull(dic)) {
		return value
	}
	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
		let index = 0
		index = findArray(dic, value)
		if (index !== -1) {
			result = dic[index].label
		} else {
			result = value
		}
	} else if (value instanceof Array) {
		result = []
		let index = 0
		value.forEach((ele) => {
			index = findArray(dic, ele)
			if (index !== -1) {
				result.push(dic[index].label)
			} else {
				result.push(value)
			}
		})
		result = result.toString()
	}
	return result
}
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
	for (let i = 0; i < dic.length; i++) {
		if (dic[i].value === value) {
			return i
		}
	}
	return -1
}
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
	let random = ''
	random = Math.ceil(Math.random() * 100000000000000)
		.toString()
		.substr(0, len || 4)
	if (date) {
		random = random + Date.now()
	}
	return random
}
/**
 * 打开小窗口
 */
export const openWindow = (url, title, w, h) => {
	// Fixes dual-screen position                            Most browsers       Firefox
	const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
	const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top

	const width = window.innerWidth
		? window.innerWidth
		: document.documentElement.clientWidth
		? document.documentElement.clientWidth
		: screen.width
	const height = window.innerHeight
		? window.innerHeight
		: document.documentElement.clientHeight
		? document.documentElement.clientHeight
		: screen.height

	const left = width / 2 - w / 2 + dualScreenLeft
	const top = height / 2 - h / 2 + dualScreenTop
	const newWindow = window.open(
		url,
		title,
		'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' +
			w +
			', height=' +
			h +
			', top=' +
			top +
			', left=' +
			left,
	)

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus()
	}
}

/**
 *  <img> <a> src 处理
 * @returns {PromiseLike<T | never> | Promise<T | never>}
 */
export function handleImg(url, id) {
	return validatenull(url)
		? null
		: request({
				url: url,
				method: 'get',
				responseType: 'blob',
		  }).then((response) => {
				// 处理返回的文件流
				const blob = response.data
				const img = document.getElementById(id)
				img.src = URL.createObjectURL(blob)
				window.setTimeout(function () {
					window.URL.revokeObjectURL(blob)
				}, 0)
		  })
}

export function handleDown(filename, bucket) {
	return request({
		url: '/admin/sys-file/' + bucket + '/' + filename,
		method: 'get',
		responseType: 'blob',
	}).then((response) => {
		// 处理返回的文件流
		const blob = response.data
		const link = document.createElement('a')
		link.href = URL.createObjectURL(blob)
		link.download = filename
		document.body.appendChild(link)
		link.click()
		window.setTimeout(function () {
			URL.revokeObjectURL(blob)
			document.body.removeChild(link)
		}, 0)
	})
}

export function getQueryString(url, paraName) {
	return getQueryObj(url)[paraName] || ''
}

export function getQueryObj(url = '') {
	let tempObj = {}
	if (!url || !url.includes('?')) {
		return tempObj
	}
	const arrObj = url.split('?')
	if (arrObj.length > 1) {
		const arrPara = arrObj[1].split('&')
		let arr
		for (let i = 0; i < arrPara.length; i++) {
			arr = arrPara[i].split('=')
			tempObj[arr[0]] = arr[1]
		}
	}
	return tempObj
}

export function handleDownSettle(url, data, filename) {
	return handleDownCustom(url, data, filename, 'put')
}

//通过url 下载职业类别表
export function handleDownCategoryFile(url, data, filename) {
	return handleDownCustom(url, data, filename, 'get')
}

//通过url 下载文件通用版
export function handleDownCustom(url, data, filename, method = 'get') {
	let reqContent = {
		url: url,
		method: method,
		responseType: 'blob',
	}
	if (method === 'get') {
		reqContent.params = data
	} else {
		reqContent.data = data
	}
	return new Promise((resolve, reject) => {
		request(reqContent)
			.then((response) => {
				// 处理返回的文件流
				const blob = response.data
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = filename
				document.body.appendChild(link)
				link.click()
				window.setTimeout(function () {
					URL.revokeObjectURL(blob)
					document.body.removeChild(link)
				}, 100)
				resolve()
			})
			.catch(() => {
				reject()
			})
	})
}

//下载文件,文件
export function downloadImg(data, name) {
	if (!data) {
		return
	}
	getUrlBase64(data).then((base64) => {
		let a = document.createElement('a')
		a.style.display = 'none'
		a.download = name
		a.href = base64
		document.body.appendChild(a)
		a.click()
		window.setTimeout(function () {
			document.body.removeChild(a)
		}, 100)
	})
}

export function getUrlBase64(url) {
	return new Promise((resolve) => {
		let canvas = document.createElement('canvas')
		let ctx = canvas.getContext('2d')
		let img = new Image()
		img.crossOrigin = 'Anonymous' //允许跨域
		img.src = url
		img.onload = function () {
			canvas.width = 1200
			canvas.height = 675
			ctx.drawImage(img, 0, 0, 1200, 675)
			let dataURL = canvas.toDataURL('image/png')
			canvas = null
			resolve(dataURL)
		}
	})
}

export function openPdfUrl(url, fileName = '') {
	if (fileName) {
		downloadFile(url, fileName)
		return
	}
	const link = document.createElement('a')
	link.href = url

	link.target = '_blank'
	document.body.appendChild(link)
	link.click()
	window.setTimeout(function () {
		document.body.removeChild(link)
	}, 0)
}

/**
 * 获取 blob
 * url 目标文件地址
 */
function getBlob(url) {
	return new Promise((resolve) => {
		const xhr = new XMLHttpRequest()
		xhr.open('GET', url, true)
		xhr.responseType = 'blob'
		xhr.onload = () => {
			if (xhr.status === 200) {
				resolve(xhr.response)
			}
		}
		xhr.send()
	})
}

/**
 * 保存 blob
 * filename 想要保存的文件名称
 */
function saveAs(blob, filename) {
	if (window.navigator.msSaveOrOpenBlob) {
		navigator.msSaveBlob(blob, filename)
	} else {
		const link = document.createElement('a')
		const body = document.querySelector('body')

		link.href = window.URL.createObjectURL(blob)
		link.download = filename
		// fix Firefox
		link.style.display = 'none'
		body.appendChild(link)
		link.click()
		body.removeChild(link)
		window.URL.revokeObjectURL(link.href)
	}
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
function downloadFile(url, filename) {
	getBlob(url).then((blob) => {
		saveAs(blob, filename)
	})
}

//通过身份证号 获取年龄
export function getAgeByCardNo(cardNo = '') {
	if (cardNo === '') {
		return 0
	}
	if (cardNo.length === 18) {
		return new Date().getFullYear() - cardNo.substring(6, 10)
	}
	if (cardNo.length === 15) {
		return new Date().getFullYear() - cardNo.substring(6, 8)
	}
}

//转换区域
export function convertAreaCode(areaCode = '') {
	if (areaCode !== '') {
		return [`${areaCode.substr(0, 2)}0000`, `${areaCode.substr(0, 4)}00`, areaCode]
	}
	return []
}

const uploadAliOss = function (data, url) {
	return axios({
		url,
		method: 'POST',
		data,
		processData: false,
		cache: false,
		contentType: false,
		withCredentials: false,
	})
}

//生成唯一id
export function uuid(length) {
	return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
}

//阿里云上传
export function uploadOss(file, data) {
	let type =
		file.type && file.type.indexOf('vnd.openxmlformats-officedocument') == -1
			? file.type.split('/')[1]
			: file.name.substring(file.name.lastIndexOf('.') + 1)
	const formData = new FormData()

	console.log('uploadOss', file)
	let fileName = `${file.name || uuid(12) + '.' + type}`, //生成文件名
		pathName = `${data.dir}/${uuid(12)}/${fileName}` //相对路径
	formData.append('key', pathName) //key 唯一值  即相对路径
	formData.append('policy', data.policy) //服务器返回的policy
	formData.append('OSSAccessKeyId', data.accessid) //服务器返回的accessId
	formData.append('success_action_status', '200') //定义成功为200
	formData.append('signature', data.signature) //服务器返回的signature
	formData.append('callback', data.callback) //服务器返回的signature
	formData.append('file', file)
	return uploadAliOss(formData, data.host)
	// return { key: pathName.replace('memsaas/', '/'), res }
}

/**
 * 直接下载路径
 * @param url
 * @param newFileName
 */
export function downloadAndRenameFile(url, newFileName) {
	//转换为promise
	return new Promise((resolve, reject) => {
		// 发起网络请求获取文件
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					reject(response.statusText || 'downloadAndRenameFile：下载失败')
				}
				return response.blob() // 将响应体转换为Blob对象
			})
			.then((blob) => {
				// 创建一个链接元素用于下载
				const downloadUrl = window.URL.createObjectURL(blob)
				const link = document.createElement('a') // 创建一个a标签
				link.href = downloadUrl
				link.download = newFileName // 设置下载文件的名称
				document.body.appendChild(link)
				link.click() // 模拟点击实现下载
				document.body.removeChild(link) // 下载后移除元素
				window.URL.revokeObjectURL(downloadUrl) // 释放URL对象
				resolve()
			})
			.catch((error) => {
				console.error('Download error:', error)
				reject(error.message || 'downloadAndRenameFile：下载失败')
			})
	})
}

/**
 * 下载本地文件 佣金券渠道模板
 */
export function downloadLocalFile(fileName) {
	let xhr = new XMLHttpRequest()
	xhr.open('GET', `/download/${fileName}.xlsx`)
	xhr.responseType = 'blob'
	xhr.onload = () => {
		FileSaver.saveAs(xhr.response, fileName)
		Message.success('下载成功！')
	}
	xhr.send()
}

/**
 * 根据文件URL获取文件类型
 * @param {string} url 文件URL
 * @returns {string} 文件类型
 */
export function getFileType(url) {
	if (!url) return 'unknown'
	
	// 获取文件扩展名
	const extension = url.split('.').pop().toLowerCase()
	
	// Excel文件
	if (['xls', 'xlsx', 'xlsm', 'xlsb', 'csv'].includes(extension)) {
		return 'excel'
	}
	
	// 视频文件
	if (['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm', 'm4v'].includes(extension)) {
		return 'video'
	}
	
	// PPT文件
	if (['ppt', 'pptx', 'pps', 'ppsx'].includes(extension)) {
		return 'ppt'
	}
	
	// PDF文件
	if (['pdf'].includes(extension)) {
		return 'pdf'
	}
	
	// 图片文件
	if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico'].includes(extension)) {
		return 'image'
	}
	
	// Word文件
	if (['doc', 'docx', 'docm', 'dotx', 'dotm'].includes(extension)) {
		return 'word'
	}
	
	return 'unknown'
}

/**
 * 根据文件URL获取文件图标
 * @param {string} url 文件URL
 * @returns {string} 图标URL
 */
export function getFileIcon(url) {
	const fileType = getFileType(url)

	switch (fileType) {
		case 'excel':
			return 'https://file.meibaokeji.com/safety/img/file_xls_icon.png'
		case 'video':
			return 'https://file.meibaokeji.com/safety/img/file_video_icon.png'
		case 'ppt':
			return 'https://file.meibaokeji.com/safety/img/file_ppt_icon.png'
		case 'pdf':
			return 'https://file.meibaokeji.com/safety/img/file_pdf_icon.png'
		case 'image':
			return 'https://file.meibaokeji.com/safety/img/file_image_icon.png'
		case 'word':
			return 'https://file.meibaokeji.com/safety/img/file_doc_icon.png'
		default:
			return 'https://file.meibaokeji.com/safety/img/file_unknown_icon.png'
	}
}
